import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';

import { Container, BlockInstrucao } from './styles';

export default function WhatMensagemCreate({ match }) {
  const inputRef = useRef(null);
  const [isFeriado, setIsFeriado] = useState(false);
  const [carregar, setCarregar] = useState(false);

  const dataTemplate = [
    {
      value: 1,
      label: 'Sim',
    },
    {
      value: 2,
      label: 'Não',
    },
  ];

  // Buscando os dados da api

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      const { whatsapp_id } = match.params;
      inputRef.current.setErrors({});

      let schema;

      if (isFeriado) {
        schema = Yup.object().shape({
          feriado: Yup.string(
            'Selecione se a mensagem e para o feriado'
          ).required('Selecione se a mensagem e para o feriado'),
          mensagem: Yup.string().required('Preencha o campo mensagem'),
        });
      } else {
        schema = Yup.object().shape({
          feriado: Yup.string(
            'Selecione se a mensagem e para o feriado'
          ).required('Selecione se a mensagem e para o feriado'),
          depois_horario: Yup.string(
            'Selecione se a mensagem e para o feriado'
          ).required('Selecione se a mensagem e para o feriado'),
          mensagem: Yup.string().required('Preencha o campo mensagem'),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/whatsapp/${whatsapp_id}/mensagens`, {
        feriado: data.feriado,
        depois_horario: isFeriado ? null : data.depois_horario,
        mensagem: data.mensagem,
      });

      toast.success('Mensagem criado com sucesso');

      reset();
      history.push(`/mensagem-edit/${whatsapp_id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao criar mensagem, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  function handleVerificarSeEFeriado(e) {
    if (e.value === 1) {
      setIsFeriado(true);
    } else {
      setIsFeriado(false);
    }
  }

  return (
    <Container>
      <h4>Criar Mensagem</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Select
            name="feriado"
            labelSelect="Mensagens para o feriado"
            options={dataTemplate}
            onChange={e => handleVerificarSeEFeriado(e)}
          />
          {!isFeriado && (
            <Select
              name="depois_horario"
              labelSelect="Mensagens para depois do horario de expediente"
              options={dataTemplate}
            />
          )}
          <Input icon="MdMail" name="mensagem" label="Mensagem" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
        <BlockInstrucao>
          <h3>Instruções de variaveis para montar suas mensagens</h3>
          <p>
            <strong>[NAME_USER]</strong> = Nome do atendente
          </p>
          <p>
            <strong>[NAME_CLIENTE]</strong> = Nome do cliente
          </p>
          <p>
            <strong>[NAME_INCORPORADORA]</strong> = Nome da incorporadora
          </p>
          <p>
            <strong>[NAME_PRODUTO]</strong> = Nome do produto
          </p>
        </BlockInstrucao>
      </Card>
    </Container>
  );
}

WhatMensagemCreate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      whatsapp_id: PropTypes.string,
    }),
  }).isRequired,
};
